import { Guid } from "guid-typescript";
import { Activity } from "../../types/activity";
import { ConfigColumns2 } from "../../types/configColumns2";
import React from "react";
import { Tooltip } from "react-tooltip";
import { renderToString } from "react-dom/server";
import { translateString } from "../../translations/gridTranslationHelper";
import { Culture } from "../../types/culture";
import { Site } from "../../types/site";
import { isUsSite } from "../../aplUtils/sitesHelper";

const getClass = (data: Activity) => (data.isConsumptionLabellingDifferent ? "nowrap text-danger" : "nowrap");

const getConsumptionDefaultColumns = (site: Site, culture: Culture): ConfigColumns2[] => {
    const lineId = { data: "lineId", visible: false, width: "0px", title: "lineId" };
    const lineSapCode = {
        data: "lineSapCode",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "10%",
        title: "workCenter",
        visible: true
    };
    const linePlantCode = {
        data: "linePlantCode",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "10%",
        title: "line",
        visible: true
    };
    const lineDescription = {
        data: "lineDescription",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "10%",
        title: "lineDescription",
        visible: true
    };
    const workOrder = {
        data: "workOrder",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "10%",
        title: "workOrder",
        visible: true,
        render: (data: Activity) => {
            if (data.isConsumptionLabellingDifferent) {
                const tooltipId = Guid.create();
                return (
                    <React.Fragment>
                        <Tooltip
                            id={`bob-tooltip-${tooltipId}`}
                            html={renderToString(<span>{translateString("differentWOOnConsumptionAndLabeling2", culture)}</span>)}
                        />
                        <span data-tooltip-delay-hide={333} data-tooltip-id={`bob-tooltip-${tooltipId}`}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                fill="currentColor"
                                className="bi bi-exclamation-triangle"
                                viewBox="0 0 16 16"
                            >
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"></path>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"></path>
                            </svg>
                        </span>
                        &nbsp;
                        {data.workOrder}
                    </React.Fragment>
                );
            }
            return (
                <React.Fragment>
                    <span>{data.workOrder}</span>
                </React.Fragment>
            );
        }
    };
    const batch = { data: "batch", className: "nowrap align-middle", classNameFunc: getClass, width: "10%", title: "batch", visible: true };
    const lot = { data: "lot", className: "nowrap align-middle", classNameFunc: getClass, width: "10%", title: "lot", visible: true };
    const materialSapCode = {
        data: "materialSapCode",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "10%",
        title: "material",
        visible: true
    };
    const description1 = {
        data: "description1",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "24%",
        title: "description",
        visible: true
    };
    const consumedPallets = {
        data: "consumedPallets",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "10%",
        title: "palletsQty",
        visible: true
    };
    const palBlockResortCount = {
        data: "palBlockResortCount",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "10%",
        title: "blockResort",
        visible: true
    };
    const palBlockQiCount = {
        data: "palBlockQiCount",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "10%",
        title: "blockQi",
        visible: true
    };
    const palBlockPackagingCount = {
        data: "palBlockPackagingCount",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "10%",
        title: "blockPackaging",
        visible: true
    };
    const speakingPartNo = {
        data: "speakingPartNo",
        className: "nowrap align-middle",
        classNameFunc: getClass,
        width: "10%",
        title: "material12",
        visible: true
    };

    let columns: ConfigColumns2[];

    if (site.siteId === 7) {
        columns = [
            lineId,
            lineSapCode,
            linePlantCode,
            workOrder,
            lot,
            materialSapCode,
            description1,
            consumedPallets,
            palBlockResortCount,
            palBlockQiCount,
            palBlockPackagingCount
        ];
    } else if (site.siteId === 19) {
        columns = [
            lineId,
            lineSapCode,
            lineDescription,
            workOrder,
            batch,
            materialSapCode,
            description1,
            consumedPallets,
            palBlockResortCount,
            palBlockQiCount,
            palBlockPackagingCount
        ];
    } else if (site.siteId > 0 && site.siteId <= 4) {
        columns = [
            lineId,
            lineSapCode,
            linePlantCode,
            workOrder,
            batch,
            materialSapCode,
            speakingPartNo,
            description1,
            consumedPallets,
            palBlockResortCount,
            palBlockQiCount,
            palBlockPackagingCount
        ];
    } else if (isUsSite(site)) {
        columns = [
            lineId,
            lineSapCode,
            linePlantCode,
            workOrder,
            materialSapCode,
            description1,
            consumedPallets,
            palBlockResortCount,
            palBlockQiCount,
            palBlockPackagingCount
        ];
    } else {
        columns = [
            lineId,
            lineSapCode,
            linePlantCode,
            workOrder,
            batch,
            materialSapCode,
            description1,
            consumedPallets,
            palBlockResortCount,
            palBlockQiCount,
            palBlockPackagingCount
        ];
    }

    return columns;
};

export { getConsumptionDefaultColumns };
